{
  "sectionTitle": "Yhteisöt",
  "joinLanding": {
    "title": "Olet liittymässä yhteisöön {{society}}",
    "description": "Liittyminen vaatii Impact-tilin. Luo tili tai kirjaudu sisään, niin liityt automaattisesti.",
    "createAccount": "Luo tili",
    "signIn": "Kirjaudu sisään",
    "confirmAs": "Olet kirjautunut tilillä {{account}}. Haluatko liittyä tällä tilillä?",
    "confirm": "Liity",
    "invalidTitle": "Linkki ei kelpaa",
    "invalidBody": "Liittymislinkki on virheellinen tai vanhentunut. Pyydä yhteisöltä uusi linkki. Voit myös liittyä koodilla profiilisivullasi.",
    "errorTitle": "Jokin meni pieleen",
    "errorBody": "Liittymislinkin lataaminen epäonnistui. Tarkista verkkoyhteytesi ja yritä uudelleen.",
    "retry": "Yritä uudelleen",
    "goHome": "Siirry etusivulle"
  },
  "joinedAt": "Liittynyt {{date}}",
  "leave": "Poistu",
  "leaveTitle": "Poistu yhteisöstä?",
  "leaveBody": "Et enää näe <strong>{{society}}in</strong> tapahtumia etkä voi ilmoittautua niihin. Voit liittyä uudelleen vain uudella kutsulla.",
  "invite": {
    "subtitle": "Kutsui sinut jäseneksi yhteisöön",
    "accept": "Hyväksy",
    "accepted": "Liityit yhteisöön {{society}}.",
    "decline": "Hylkää",
    "declineTitle": "Hylkää kutsu?",
    "declineBody": "Hylkäätkö kutsun yhteisöön <strong>{{society}}</strong>? Voit liittyä myöhemmin vain uudella kutsulla."
  },
  "empty": {
    "title": "Et kuulu vielä yhteisöihin",
    "description": "Kun sinut kutsutaan yhteisöön, kutsu ilmestyy tähän. Voit myös liittyä koodilla."
  },
  "join": {
    "sectionTitle": "Liity yhteisöön",
    "description": "Syötä yhteisön liittymiskoodi tai skannaa QR-koodi liittyäksesi.",
    "label": "Liity yhteisöön koodilla:",
    "labelMore": "Liity uuteen yhteisöön koodilla:",
    "codePlaceholder": "Liittymiskoodi",
    "submit": "Liity",
    "scanQr": "Skannaa QR-koodi",
    "success": "Liityit yhteisöön {{society}}.",
    "error": "Liittyminen epäonnistui. Tarkista koodi ja yritä uudelleen.",
    "scanTitle": "Skannaa liittymiskoodi",
    "scanInstructions": "Suuntaa kamera yhteisön QR-koodiin.",
    "scanCameraError": "Kameraa ei voitu käyttää. Tarkista kameran käyttöoikeudet."
  }
}
